import React, {useState, useEffect} from "react";
import {
    Box,
    Container,
    Paper,
    Typography,
    FormControl,
    Alert,
    //InputLabel,
    CircularProgress, Autocomplete, TextField
} from "@mui/material";
import WhereToVote from "@mui/icons-material/WhereToVote";
import * as ENV from 'env/env';


import globalPlanLa12 from "assets/img/roomsLocations/global_plan_la-12.png";
import globalPlanAngle from "assets/img/roomsLocations/global_plan_angle.png";
import globalPlanLumieres from "assets/img/roomsLocations/global_plan_les-lumieres.png";
import globalPlanChambree from "assets/img/roomsLocations/global_plan_chambree.png";
import globalPlanGrangeMarie1 from "assets/img/roomsLocations/global_plan_grange-marie1.png";
import globalPlanGrangeMarie2 from "assets/img/roomsLocations/global_plan_grange-marie2.png";
import globalPlanGrangeMarie3 from "assets/img/roomsLocations/global_plan_grange-marie3.png";
import globalPlanMaisonAlice from "assets/img/roomsLocations/global_plan_maison-alice.png";
import globalPlanMaisonPierre from "assets/img/roomsLocations/global_plan_maison-pierre.png";
import globalPlanMaisonPrincipale from "assets/img/roomsLocations/global_plan_maison-principale.png";

import rdcAngle from "assets/img/roomsLocations/angle-rdc.png";
import rdcLumieres from "assets/img/roomsLocations/lumieres-rdc.png";
import rdcChambree from "assets/img/roomsLocations/chambree.png";
import rdcGrangeMarie1 from "assets/img/roomsLocations/grange-marie_rdc1.png";
import rdcGrangeMarie2 from "assets/img/roomsLocations/grange-marie_rdc2.png";
import rdcMaisonAlice from "assets/img/roomsLocations/maison-alice.png";
import rdcMaisonPierre from "assets/img/roomsLocations/maison-pierre_rdc.png";
import rdcMaisonPrincipale from "assets/img/roomsLocations/maison-principale_rdc.png";

import upstairsAngle from "assets/img/roomsLocations/angle-etage.png";
import upstairsLumieres from "assets/img/roomsLocations/lumieres-etage.png";
import upstairsGrangeMarie3 from "assets/img/roomsLocations/grange-marie_etage3.png";
import upstairsMaisonPierre from "assets/img/roomsLocations/maison-pierre_etage.png";
import upstairsMaisonPrincipale from "assets/img/roomsLocations/maison-principale-etage.png";


import goUpstairsAngle from "assets/img/roomsLocations/angle_go-upstairs.png";
import goUpstairsLumieres from "assets/img/roomsLocations/lumieres_go-upstairs.png";
import goUpstairsGrangeMarie3 from "assets/img/roomsLocations/grange-marie_go-upstairs3.png";
import goUpstairsMaisonPierre from "assets/img/roomsLocations/maison-pierre_go-upstairs.png";
import goUpstairsMaisonPrincipale from "assets/img/roomsLocations/maison-principale_go-upstairs.png";

interface Guest {
    name: string;
    surname: string;
    bat: string;
    floor: string;
    room: string;
    fullName: string;
}

const globalPlansImages: Record<string, string> = {
    "L'Angle": globalPlanAngle,
    "La 12": globalPlanLa12,
    "Les Lumières": globalPlanLumieres,
    "Chambrée": globalPlanChambree,
    "Grange de Marie 1" : globalPlanGrangeMarie1,
    "Grange de Marie 2" : globalPlanGrangeMarie2,
    "Grange de Marie 3" : globalPlanGrangeMarie3,
    "Maison d'Alice": globalPlanMaisonAlice,
    "Maison de Pierre": globalPlanMaisonPierre,
    "Maison principale": globalPlanMaisonPrincipale,
};

const rdcImages: Record<string, string> = {
    "L'Angle": rdcAngle,
    "Les Lumières": rdcLumieres,
    "Chambrée": rdcChambree,
    "Grange de Marie 1": rdcGrangeMarie1,
    "Grange de Marie 2": rdcGrangeMarie2,
    "Maison d'Alice": rdcMaisonAlice,
    "Maison de Pierre": rdcMaisonPierre,
    "Maison principale": rdcMaisonPrincipale,
};

const upstairsImages: Record<string, string> = {
    "L'Angle": upstairsAngle,
    "Les Lumières": upstairsLumieres,
    "Grange de Marie 3": upstairsGrangeMarie3,
    "Maison de Pierre": upstairsMaisonPierre,
    "Maison principale": upstairsMaisonPrincipale,
};
const goUpstairsImages: Record<string, string> = {
    "L'Angle": goUpstairsAngle,
    "Les Lumières": goUpstairsLumieres,
    "Grange de Marie 3": goUpstairsGrangeMarie3,
    "Maison de Pierre": goUpstairsMaisonPierre,
    "Maison principale": goUpstairsMaisonPrincipale,
};

const StayFindMyRoom: React.FC = () => {
    const [selectedName, setSelectedName] = useState("");
    const [roomNumber, setRoomNumber] = useState("");
    const [globalPlan, setGlobalPlan] = useState("");
    const [rdcPlan, setRdcPlan] = useState("");
    const [floor, setFloor] = useState("");
    const [upstairsPlan, setUpstairsPlan] = useState("");
    const [goUpstairsPlan, setGoUpstairsPlan] = useState("");
    const [batName, setBatName] = useState<string>("");
    const [displayedBatName, setDisplayedBatName] = useState<string>("");
    const [guests, setGuests] = useState<Guest[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const SPREADSHEET_ID = ENV.SPREADSHEET_ID;
    const API_KEY = ENV.GOOGLE_API_KEY;
    const SHEET_NAME = "Liste";

    useEffect(() => {
        const fetchGuestsFromSheet = async () => {
            try {
                const url = `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${SHEET_NAME}?key=${API_KEY}`;

                const response = await fetch(url);

                if (!response.ok) {
                    const errorData = await response.json();
                    console.error("Erreur API:", errorData);

                    if (response.status === 403) {
                        throw new Error(
                            "Accès refusé. Assurez-vous que le Google Sheet est public (Partager > Tous les utilisateurs disposant du lien)"
                        );
                    } else if (response.status === 404) {
                        throw new Error(
                            "Sheet non trouvé. Vérifiez l'ID du spreadsheet et le nom de la feuille"
                        );
                    } else {
                        throw new Error(`Erreur ${response.status}: ${errorData.error?.message || 'Erreur inconnue'}`);
                    }
                }

                const data = await response.json();
                const rows = data.values || [];

                if (rows.length === 0) {
                    throw new Error("Le Google Sheet est vide");
                }

                const guestsData = rows.slice(1)
                    .map((row: any[]) => ({
                        name: row[0] || "",
                        surname: row[1] || "",
                        bat: row[2] || "",
                        floor: row[3] || "",
                        room: row[4] || "",
                        fullName: `${row[1] || ""} ${row[0] || ""}`.trim()
                    }))
                    .filter((guest: Guest) =>
                        guest.bat && guest.bat.trim() !== ""
                    );

                setGuests(guestsData);
                setError(null);
            } catch (err) {
                const errorMessage = err instanceof Error ? err.message : "Impossible de charger les données des chambres.";
                setError(errorMessage);
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchGuestsFromSheet();
    }, []);

    const handleNameChange = (event: React.SyntheticEvent, newValue: Guest | null) => {
        if (newValue) {
            setSelectedName(newValue.fullName);
            setBatName(newValue.bat);
            setGlobalPlan(globalPlansImages[newValue.bat]);
            setRdcPlan(rdcImages[newValue.bat]);
            setGoUpstairsPlan(goUpstairsImages[newValue.bat]);
            setRoomNumber(newValue.room);
            setFloor(newValue.floor);

            if (newValue.floor === "Etage") {
                setUpstairsPlan(upstairsImages[newValue.bat]);
            } else {
                setUpstairsPlan("");
            }
            if (newValue.bat.startsWith("Grange de Marie")) {
                setDisplayedBatName("Grange de Marie");

            } else {
                setDisplayedBatName(newValue.bat);
            }

        } else {
            setSelectedName("");
            setBatName("");
            setGlobalPlan("");
            setRdcPlan("");
            setUpstairsPlan("");
        }
    };

    return (
        <Container maxWidth="md" sx={{mb: 4}}>
            <Paper elevation={3} sx={{p: {xs: 3, md: 5}, borderRadius: 3}}>
                <Box>
                    <Box sx={{display: 'flex', alignItems: 'center', mb: 2}}>
                        <WhereToVote sx={{mr: 2, color: 'primary.main', fontSize: 30}}/>
                        <Typography variant="h5">Où se trouve ma chambre ?</Typography>
                    </Box>
                    <Typography variant="body1" sx={{mb: 2}}>
                        Afin de localiser facilement votre chambre au Domaine de la Pépinière, vous pouvez chercher
                        votre nom dans la liste suivante :
                    </Typography>
                    <Box sx={{mt: 3}}>
                        {loading ? (
                            <Box sx={{display: 'flex', justifyContent: 'center'}}>
                                <CircularProgress/>
                            </Box>
                        ) : error ? (
                            <Alert severity="error">{error}</Alert>
                        ) : guests.length === 0 ? (
                            <Alert severity="warning">
                                Aucune chambre n'a encore été attribuée.
                            </Alert>
                        ) : (
                            <>
                                <FormControl fullWidth sx={{maxWidth: 400}}>

                                    <Autocomplete
                                        options={guests}
                                        getOptionLabel={(option) => option.fullName}
                                        value={guests.find(g => g.fullName === selectedName) || null}
                                        onChange={handleNameChange}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Trouver ma chambre"
                                                placeholder="Commencez à taper un nom..."
                                            />
                                        )}
                                        fullWidth
                                        sx={{maxWidth: 400}}
                                    />
                                </FormControl>
                                {selectedName && (<>
                                    <Alert severity="info" sx={{mt: 2}}>
                                        Pour rejoindre votre chambre, rendez-vous au
                                        bâtiment <strong>{displayedBatName}</strong> par l'entrée indiquée par la flèche
                                        violette.
                                    </Alert>
                                    {globalPlan && (
                                        <Box sx={{mt: 3, textAlign: 'center'}}>
                                            <img
                                                src={globalPlan}
                                                alt={`Plan du bâtiment ${batName}`}
                                                style={{
                                                    width: '100%',
                                                    maxWidth: '100%',
                                                    height: 'auto',
                                                    borderRadius: 12,
                                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                                                }}
                                            />
                                        </Box>
                                    )}

                                    {floor == "RDC" && (<><Alert severity="info" sx={{mt: 2}}>
                                        Une fois à l'intérieur vous trouverez
                                        votre   chambre, <strong>la numéro {roomNumber}</strong>, au RDC !
                                    </Alert>
                                        {rdcPlan && (
                                            <Box sx={{mt: 3, textAlign: 'center'}}>
                                                <img
                                                    src={rdcPlan}
                                                    alt={`Plan du RDC du bâtiment ${batName}`}
                                                    style={{
                                                        width: '100%',
                                                        maxWidth: '100%',
                                                        height: 'auto',
                                                        borderRadius: 12,
                                                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                                                    }}
                                                />
                                            </Box>
                                        )}</>)}

                                    {floor == "Etage" && (<Alert severity="info" sx={{mt: 2}}>
                                        Pour monter à l'étage, suivez les flèches violettes.
                                    </Alert>)}
                                    {upstairsPlan && (

                                        <>

                                            <Box sx={{mt: 3, textAlign: 'center'}}>
                                                <img
                                                    src={goUpstairsPlan}
                                                    alt={`Plan du RDC du bâtiment ${batName}`}
                                                    style={{
                                                        width: '100%',
                                                        maxWidth: '100%',
                                                        height: 'auto',
                                                        borderRadius: 12,
                                                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                                                    }}
                                                />
                                            </Box>

                                            <Alert severity="info" sx={{mt: 2}}>
                                                Une fois en haut, vous trouverez votre chambre, <strong>la numéro {roomNumber}</strong>
                                            </Alert>
                                        <Box sx={{mt: 3, textAlign: 'center'}}>
                                            <img
                                                src={upstairsPlan}
                                                alt={`Plan de l'étage du bâtiment ${batName}`}
                                                style={{
                                                    width: '100%',
                                                    maxWidth: '100%',
                                                    height: 'auto',
                                                    borderRadius: 12,
                                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                                                }}
                                            />
                                        </Box></>
                                    )}
                                </>)}
                            </>
                        )}
                    </Box>
                </Box>
            </Paper>
        </Container>
    )
        ;
};

export default StayFindMyRoom;